import type { IFetcher } from "../../util/io/Fetcher";

export interface IHeartBeatFetcher {
	pulse(): Promise<void>;
}

export class HeartBeatFetcher implements IHeartBeatFetcher {
	constructor(private readonly fetcher: IFetcher) {}

	async pulse(): Promise<void> {
		const { fetcher } = this;
		const url = "/POW4/HeartBeat";
		await fetcher.getJSON(url);
	}
}
